import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastMessageService {

  constructor(private toastr: ToastrService) { }

  success(message) {
    this.toastr.success(message, 'Success');
  }

  info(message) {
    this.toastr.info(message, 'Info');
  }

  error(message) {
    this.toastr.error(message, 'Error');
  }
}
